import NavTabOutlet from "components/elements/NavTabOutlet";
import { ERuleNames, useHasRules } from "components/materials/HasRules";
import I18n from "components/materials/I18n";
import PageTemplate from "components/PageTemplate";
import ModuleConfig from "configs/ModuleConfig";
import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { container } from "tsyringe";

import classes from "./classes.module.scss";

const clientsPages = container.resolve(ModuleConfig).get().modules.pages.Clients;

function Client() {
	const { corporationId } = useParams();
	const navigate = useNavigate();
	// Only the provider history accepts both roles. The other tabs require the CGP rule
	// and would redirect a middle office user to the login screen.
	const canAccessCgpTabs = useHasRules({ AND: { [ERuleNames.access_platform__cgp]: true } });
	// La liste des clients est réservée au CGP. Un middle office arrive ici depuis
	// une souscription : le retour par défaut, navigate(-1), l'y ramène.
	const navigateToClients = useCallback(() => {
		navigate(clientsPages.props.pages.Corporations.props.path);
	}, [navigate]);

	if (!corporationId) return;
	return (
		<PageTemplate
			tabTitle={I18n.trslt(I18n.asset.pages.client.page_title)}
			backArrow={{
				enabled: true,
				...(canAccessCgpTabs ? { overridePreviousClick: { onClick: navigateToClients, text: I18n.asset.common.back_to_clients } } : {}),
			}}>
			<div className={classes["root"]}>
				<NavTabOutlet
					items={[
						{
							cgpOnly: true,
							label: I18n.trslt(I18n.asset.pages.client.sub_pages.personal_information.page_title),
							path: clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.PersonalInformation.props.path.replace(
								":corporationId",
								corporationId,
							),
							activePaths: [clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.PersonalInformation.props.path],
						},
						{
							cgpOnly: true,
							label: I18n.asset.pages.client.sub_pages.validated_subscriptions.page_title,
							path: clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.ValidatedSubscriptions.props.path.replace(
								":corporationId",
								corporationId,
							),
							activePaths: [clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.ValidatedSubscriptions.props.path],
						},
						{
							label: "Historique prestataire",
							path: clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.LegacyHistory.props.path.replace(
								":corporationId",
								corporationId,
							),
							activePaths: [clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.LegacyHistory.props.path],
							// Masqué là où la reprise de l'historique prestataire n'est pas livrée (`configs/ModuleConfig`).
							enabled: clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.LegacyHistory.enabled,
						},
						{
							cgpOnly: true,
							label: I18n.trslt(I18n.asset.pages.client.sub_pages.customer_insight.page_title),
							path: clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.CustomerInsight.props.pages.PaymentMethods.props.path.replace(
								":corporationId",
								corporationId,
							),
							activePaths: [
								clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.CustomerInsight.props.pages.PaymentMethods.props.path,
								clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.CustomerInsight.props.pages.PatrimoineRevenus.props.path,
								clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.CustomerInsight.props.pages.ConnaissanceExperience.props.path,
								clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.CustomerInsight.props.pages.TestAdequation.props.path,
								clientsPages.props.pages.Corporations.props.pages.CorporationDetails.props.pages.CustomerInsight.props.pages.FinanceDurable.props.path,
							],
						},
					].filter((item) => item.enabled !== false && (item.cgpOnly !== true || canAccessCgpTabs))}
				/>
			</div>
		</PageTemplate>
	);
}

export default Client;
